import * as React from "react";
import styled from "styled-components";
const ScrollItemsWrapper = styled.div `
	display: flex;
	transition-property: transform;
	height: 100%;
	width: 100%;
	transition-timing-function: cubic-bezier(0, 0, 0.25, 1);
`;
const { Children } = React;
class BetterSwipe extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            currentIndex: this.props.defaultIndex || 1,
            animationDuration: 0,
            dragPoints: {},
            wrapperOffsetLeft: 0,
            startTime: 0,
        };
        this.windowScrollTimeoutId = 0;
        this.isStop = false;
        this.onTransitionEnd = () => {
            const { children, onIndexChange } = this.props;
            const { currentIndex } = this.state;
            const updateState = { animationDuration: 0 };
            const childrenCount = Children.count(children);
            if (childrenCount + 1 === currentIndex) {
                updateState.currentIndex = 1;
            }
            else if (currentIndex === 0) {
                updateState.currentIndex = childrenCount;
            }
            this.setState(updateState);
            if (typeof onIndexChange !== "undefined") {
                let index = currentIndex - 1;
                if (currentIndex === 0) {
                    index = childrenCount - 1;
                }
                else if (currentIndex === childrenCount + 1) {
                    index = 0;
                }
                onIndexChange(index);
            }
        };
        this.onTouchStart = (e) => {
            const { animationDuration } = this.state;
            if (animationDuration === 0 && !this.isDraging()) {
                this.stopAutoScroll();
                const touch = e.touches[0];
                const dragPoints = {
                    startPoint: {
                        x: touch.clientX,
                        y: touch.clientY,
                    },
                };
                this.setState({
                    dragPoints,
                    wrapperOffsetLeft: this.scrollItemsWrapper.getBoundingClientRect().left,
                    startTime: new Date().getTime(),
                });
            }
        };
        this.onTouchMove = (e) => {
            if (this.isDraging()) {
                const touch = e.touches[0];
                const endPoint = {
                    x: touch.clientX,
                    y: touch.clientY,
                };
                const { startPoint } = this.state.dragPoints;
                if (Math.abs(endPoint.y - startPoint.y) > Math.abs(endPoint.x - startPoint.x)) {
                    this.setState({ dragPoints: {} });
                    this.autoScroll();
                }
                else {
                    const dragPoints = Object.assign(Object.assign({}, this.state.dragPoints), { endPoint });
                    this.setState({ dragPoints });
                    e.stopPropagation();
                }
            }
        };
        this.onTouchEnd = (e) => {
            const { dragPoints, currentIndex, containerWidth, startTime } = this.state;
            const distance = this.getDistance(dragPoints);
            if (this.isDraging() && distance) {
                let updateState = {
                    dragPoints: {},
                };
                const { animationDuration = 0, swipeSensitive, speedSensitive } = this.props;
                const distanceAbs = Math.abs(distance);
                const endTime = new Date().getTime();
                const slideSpeed = (distanceAbs * 1000) / (endTime - startTime);
                if (distanceAbs >
                    Math.ceil((containerWidth * swipeSensitive) / 2) ||
                    slideSpeed > speedSensitive) {
                    const scrollNumber = Math.ceil(distanceAbs / containerWidth);
                    if (distance < 0) {
                        updateState.currentIndex = currentIndex - scrollNumber;
                    }
                    else {
                        updateState.currentIndex = currentIndex + scrollNumber;
                    }
                }
                updateState.currentIndex = Math.max(0, updateState.currentIndex);
                updateState.currentIndex = Math.min(this.getNodeCount() - 1, updateState.currentIndex);
                const duration = Math.ceil((distanceAbs / containerWidth) * animationDuration);
                const nextAnimationDuration = duration > animationDuration
                    ? animationDuration - (duration % animationDuration)
                    : Math.max(50, duration);
                updateState = Object.assign(Object.assign({}, updateState), { animationDuration: nextAnimationDuration });
                this.setState(updateState);
                this.autoScroll();
            }
            e.stopPropagation();
        };
        this.onWindowScroll = () => {
            clearTimeout(this.windowScrollTimeoutId);
            this.windowScrollTimeoutId = setTimeout(() => {
                if (this.isCotainerInCurrentScreen()) {
                    this.isStop = false;
                }
                else {
                    this.isStop = true;
                }
            }, 80);
        };
        this.onResize = () => {
            this.setState({ containerWidth: this.container.getBoundingClientRect().width });
        };
        this.getDistance = (dragPoints) => {
            const { endPoint, startPoint } = dragPoints;
            if (typeof endPoint !== "undefined" && typeof startPoint !== "undefined") {
                return startPoint.x - endPoint.x;
            }
            return 0;
        };
        this.bindContainerRef = (me) => {
            this.container = me;
        };
        this.bindScrollItemsWrapperRef = (me) => {
            this.scrollItemsWrapper = me;
        };
    }
    getNodeCount() {
        return Children.count(this.props.children) + 2;
    }
    isCotainerInCurrentScreen() {
        return this.container.getBoundingClientRect().bottom >= 0;
    }
    scrollItemsWrapperStyle() {
        const { currentIndex, dragPoints, animationDuration, containerWidth } = this.state;
        const style = {};
        style.width = `${this.getNodeCount()}00%`;
        const wrapperOffsetLeft = -1 * currentIndex * containerWidth;
        if (this.isDraging()) {
            const distance = this.getDistance(dragPoints);
            style.transform = `translate3d(${wrapperOffsetLeft - distance}px,0,0)`;
        }
        else {
            style.transform = `translate3d(${wrapperOffsetLeft}px,0,0)`;
            style.transitionDuration = `${animationDuration}ms`;
        }
        style.WebkitTransform = style.transform;
        style.transitionTimingFunction = "ease-out";
        return style;
    }
    isDraging() {
        return !!this.state.dragPoints.endPoint || !!this.state.dragPoints.startPoint;
    }
    render() {
        const { className, children } = this.props;
        const childrenNodes = Children.toArray(children);
        if (childrenNodes.length === 1) {
            return (React.createElement("div", { className: className, ref: this.bindContainerRef }, children));
        }
        return (React.createElement("div", { className: className, ref: this.bindContainerRef, onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove, onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd },
            React.createElement(ScrollItemsWrapper, { ref: this.bindScrollItemsWrapperRef, style: this.scrollItemsWrapperStyle(), onTransitionEnd: this.onTransitionEnd },
                childrenNodes.slice(-1)[0],
                children,
                childrenNodes[0])));
    }
    componentDidMount() {
        this.autoScroll();
        window.addEventListener("scroll", this.onWindowScroll);
        window.addEventListener("resize", this.onResize);
        this.setState({ containerWidth: this.container.getBoundingClientRect().width });
    }
    componentWillUnmount() {
        this.stopAutoScroll();
        clearTimeout(this.windowScrollTimeoutId);
        window.removeEventListener("scroll", this.onWindowScroll);
        window.removeEventListener("resize", this.onResize);
    }
    autoScroll() {
        const { isAutoSwipe, duration } = this.props;
        if (isAutoSwipe) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                if (!this.isStop && document.visibilityState === "visible") {
                    const { currentIndex } = this.state;
                    this.scrollByIndex(currentIndex + 1);
                }
                this.autoScroll();
            }, duration);
        }
    }
    stopAutoScroll() {
        const { isAutoSwipe } = this.props;
        if (isAutoSwipe) {
            clearTimeout(this.timeoutId);
        }
    }
    scrollByIndex(index) {
        this.setState({
            currentIndex: index,
            animationDuration: this.props.animationDuration,
        });
    }
}
BetterSwipe.defaultProps = {
    duration: 4000,
    animationDuration: 600,
    swipeSensitive: 1,
    isAutoSwipe: true,
    speedSensitive: 320,
    style: {},
};
export default BetterSwipe;
